import axios from 'axios';
import { API_URL } from '@/utils/constants';

const INSTANCE = axios.create({
    baseURL: API_URL,
});

export default INSTANCE;
